import { Button } from "@/components/ui/button"
import { FileAudio, X } from "lucide-react"
import type { UploadedFile } from "@/services"

type Props = {
  file: UploadedFile
  onRemove?: () => void
}

export function FileUploadCard({ file, onRemove }: Props) {
  return (
    <div className="flex items-center gap-3 p-3 bg-secondary/30 rounded-md">
      <FileAudio className="h-8 w-8 text-primary shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-mono font-medium truncate">{file.fileName}</p>
        <p className="text-xs text-muted-foreground">
          {(file.fileSize / 1024 / 1024).toFixed(2)} MB
        </p>
      </div>
      {onRemove && (
        <Button type="button" variant="ghost" size="sm" onClick={onRemove}>
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
